import { StyledPracticeCell } from "../../../components/Table.styled"
import { TestResult, WaterlineCalendarRow } from "./types"
import CorpCalendarTestResult from "../../../components/CorpCalendarTestResult"
import { BioCalendarRow } from "../biological-monitoring/types"

const WaterlineResultsCell = ({ practice }: {
  practice: WaterlineCalendarRow | BioCalendarRow
}) => {
  if( !('testResults' in practice)) return <StyledPracticeCell />
  return (
    <StyledPracticeCell>
      <div className="flex">
        {
          practice.testResults.map((result: TestResult, index: number) => {
            const title = `${result.message} ${result?.testDate ?? ''}`.trim()

            return (
              <CorpCalendarTestResult
                key={`${practice.practiceName}-${practice.customerNumber}-tooltip-${index}`}
                title={title}
                complianceInterval={result.complianceInterval}
                status={result.status}
              />
            )
          })
        }
      </div>
    </StyledPracticeCell>
  )
}

export default WaterlineResultsCell